import React from "react"

const JourneysContext = React.createContext({})

const { Provider, Consumer } = JourneysContext

export { Provider, Consumer, JourneysContext }
